<template>
    <li>
        <a
				class="logout"
				v-on:click.stop.prevent="logout"
				:title="'Odhlášení' | translate"
				v-translate>Odhlášení
		</a>
    </li>
</template>

<script>
	import {AUTH_LOGOUT} from "@/store/mutation-types"

	export default {
		name: "logout",
		methods: {
			logout: function () {
				this.$store.dispatch(AUTH_LOGOUT)
					.then(() => {
						this.$router.push({name: 'login'})
					})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue